export const SET_LOCATION = 'SET_LOCATION'
export const SET_LUNCH_OPTION = 'SET_LUNCH_OPTION'
export const SET_LUNCH_NOTES = 'SET_LUNCH_NOTES'
export const SET_HEALTH_QUESTIONS = 'SET_HEALTH_QUESTIONS'
export const RESET_FORM = 'RESET_FORM'
export const SET_LAST_ATTENDANCE_RATING = 'SET_LAST_ATTENDANCE_RATING'
